module.exports = __webpack_public_path__ + "img/organization_chart2.32e73719.jpg";